<template>
  <div>
    <Settings ref="settings" />
    <SuspendSales ref="openSuspendSales" />

    <nav class="navbar navbar-expand-lg dark-bg-2">
      <h4 class="h-100 ml-4 m-0 site_name font-poppins" href="#">
        {{ shopName }}
      </h4>
      <span class="ml-4">{{ dateTime }}</span>

      <ShortcutModalHelp ref="shortcutModal" id="shortcut-help-popover" />

      <b-popover
        target="shortcut-help-popover"
        triggers="hover"
        placement="top"
        class="popover-style"
      >
        <strong class="popover-text-style">Shortcut Keys</strong>
      </b-popover>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarText"
        aria-controls="navbarText"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"> </span>
      </button>
      <div class="collapse navbar-collapse" id="navbarText">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active"></li>
          <li class="nav-item"></li>
          <li class="nav-item"></li>
        </ul>
        <ul class="nav justify-content-end">
          <li class="nav-item">
            <!-------------------------- Cash Workflow -------------------------->
            <b-button
              @click="onOpenCashFlowModal()"
              variant="cash-flow"
              id="cashflow-popover"
              class="mr-3"
            >
              <i class="fa fa-money" aria-hidden="true"></i>
              Cash flow
              <CashFlowModal ref="cashFlowModal" />
            </b-button>

            <b-popover
              target="cashflow-popover"
              triggers="hover"
              placement="top"
              class="popover-style"
            >
              <strong class="popover-text-style">Cashflow </strong>
            </b-popover>

            <!-------------------------- Add Supplier -------------------------->
            <b-button
              @click="onAddSupplierModal()"
              variant="add-supplier"
              id="supplier-popover"
              class="mr-3"
            >
              <i class="fa fa-users" aria-hidden="true"></i>
              Add Supplier
              <SupplierModal ref="supplierModal" />
            </b-button>

            <b-popover
              target="supplier-popover"
              triggers="hover"
              placement="top"
              class="popover-style"
            >
              <strong class="popover-text-style">Add Supplier </strong>
            </b-popover>

            <!-------------------------- Sales Return -------------------------->

            <!-------------------------- Suspended Sales -------------------------->
            <b-button
              @click="openSuspendSalesModal()"
              variant="primary"
              class="mr-3"
              id="suspand=popover"
            >
              <i class="fa fa-archive text-white" aria-hidden="true"></i>
            </b-button>

            <b-popover
              target="suspand=popover"
              triggers="hover"
              placement="top"
              class="popover-style"
            >
              <strong class="popover-text-style">Suspend List</strong>
            </b-popover>

            <!-------------------------- Refresh the all all data  -------------------------->

            <b-button
              @click="syncData()"
              id="popover-rfresh-sync"
              variant="refresh"
              class="mr-3"
            >
              <i
                class="fa fa-refresh"
                :class="loading ? 'fa-spin' : ''"
                aria-hidden="true"
              ></i>
            </b-button>

            <b-popover
              target="popover-rfresh-sync"
              triggers="hover"
              placement="top"
              class="popover-style"
            >
              <strong class="popover-text-style">Refresh</strong>
            </b-popover>

            <!-------------------------- Customer Sales -------------------------->

            <!-------------------------- Cash Flow Summary Dropdown Menu -------------------------->
            <SummaryDropdown class="mr-3" id="popover-summary" />
            <b-popover
              target="popover-summary"
              triggers="hover"
              placement="top"
              class="popover-style"
            >
              <strong class="popover-text-style">Summary</strong>
            </b-popover>

            <!-------------------------- Full Screen -------------------------->
            <b-button
              v-if="!fullscreenView"
              id="popover-screen"
              @click="OnFullScreen"
              class="mr-3"
            >
              <i class="fa fa-arrows-alt" aria-hidden="true"></i>
            </b-button>

            <b-button
              v-else
              id="popover-screen"
              @click="OnFullScreen"
              class="mr-3"
            >
              <i class="fa fa-window-restore" aria-hidden="true"></i>
            </b-button>
            <b-popover
              target="popover-screen"
              triggers="hover"
              placement="top"
              class="popover-style"
            >
              <strong v-if="!fullscreenView" class="popover-text-style"
                >Fullscreen</strong
              >
              <strong v-else class="popover-text-style">Exit Fullscreen</strong>
            </b-popover>

            <!-------------------------- Settings Dropdown Menu -------------------------->
            <SettingsDropdown class="mr-3" id="popover-change-shop" />
            <b-popover
              target="popover-change-shop"
              triggers="hover"
              placement="top"
              class="popover-style"
            >
              <strong class="popover-text-style">Change Shop</strong>
            </b-popover>

            <!-------------------------- User Name with logout button -------------------------->
            <b-dropdown variant="orange" size="sm" split right :text="username">
              <b-dropdown-text style="width: 240px">
                {{ username }}
              </b-dropdown-text>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item class="p-0 m-0">
                <b-btn
                  @click="Logout()"
                  size="sm"
                  variant="secondary"
                  class="header_button btn_orange w-100"
                >
                  <i class="fa fa-fw fa-sign-out"></i>Logout
                </b-btn>
              </b-dropdown-item>
            </b-dropdown>
            <!-------------------------------------------------------------------------------->
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
// Components
import SuspendSales from "@/components/SuspendSales/Index";
import Settings from "@/components/Settings/index";
import SalesReturn from "@/components/saleReturn/index";
import Qutation from "@/components/qutation/index";
import SupplierModal from "@/components/supplier/index";
import CashFlowModal from "@/components/cashflow/index";
import SummaryDropdown from "@/components/cashflow/SummaryDropdown";
import ShortcutModalHelp from "@/components/shortcuthelp/index";
import SettingsDropdown from "@/components/settingsDropdown/index";
import CustomerPreviousSales from "@/components/MainPage/CustomerPreviousSales";
import { upperCase } from "lodash";

export default {
  name: "Header",
  data() {
    return {
      fullscreenView: false,
      loading: false,
      showPopups: true,
      dateTime: null,
    };
  },
  components: {
    SuspendSales,
    Settings,
    SalesReturn,
    Qutation,
    ShortcutModalHelp,
    SettingsDropdown,
    CustomerPreviousSales,
    SupplierModal,
    CashFlowModal,
    SummaryDropdown,
  },
  mounted: function () {
    if (!this.status) {
      // this.$router.push("/");
    }
    this._keyListener = function (e) {
      if (e.key == this.keyShortcuts.change_shop && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        this.$refs.settings.showModal();
      }
      if (e.key == this.keyShortcuts.suspend_sale && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        this.$refs.openSuspendSales.showModal();
      }
      if (e.key == this.keyShortcuts.refresh && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        this.syncData();
      }
    };

    document.addEventListener("keydown", this._keyListener.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this._keyListener);
  },
  methods: {
    startTimer() {
      const zeroFill = (n) => {
        return ("0" + n).slice(-2);
      };

      const interval = setInterval(() => {
        // Get current time
        const now = new Date();

        // Format date as in mm/dd/aaaa hh:ii:ss
        const dateTime =
          zeroFill(now.getMonth() + 1) +
          "/" +
          zeroFill(now.getUTCDate()) +
          "/" +
          now.getFullYear() +
          " " +
          zeroFill(now.getHours()) +
          ":" +
          zeroFill(now.getMinutes()) +
          ":" +
          zeroFill(now.getSeconds());

        // Display the date and time on the screen using div#date-time
        this.dateTime = dateTime;
      }, 1000);
    },
    openShortcutHelpModal() {
      this.$refs.shortcutModal.showModal();
    },
    ShowSettingModal() {
      this.$refs.settings.showModal();
    },
    openSuspendSalesModal() {
      this.$refs.openSuspendSales.showModal();
    },
    onOpenSalesReturn() {
      this.$refs.onOpenSaleReturn.showModal();
    },
    onOpenQutation() {
      this.$refs.onOpenQutation.showModal();
    },
    ShowCustomerSalesModal() {},
    openHelpdesk() {
      this.showPopups = !this.showPopups;

      setTimeout(() => {
        this.$store.dispatch("auth/makeVisibleTooltip", !this.showPopups);
      }, 200);
    },
    Logout() {
      localStorage.removeItem("pos_token");
      this.$store.dispatch("auth/LogOut");
      this.$router.push("/login");
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: `Message`,
        variant: variant,
        solid: true,
      });
    },
    syncData() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.showToast("Sync successful", "success");
      }, 2000);

      this.$store.dispatch("fetchAllData");
      this.$store.dispatch("product/fetchProducts");
      this.$store.dispatch("product/FetchAllBrands");
      this.$store.dispatch("product/FetchAllCategories");
      this.$store.dispatch("warehouse/fetchWarehouses");
    },
    OnFullScreen() {
      if (this.fullscreenView) {
        this.fullscreenView = false;
        document.exitFullscreen();
      } else {
        this.fullscreenView = true;
        document.documentElement.requestFullscreen();
      }
    },
    onOpenCashFlowModal() {
      this.$refs.cashFlowModal.showModal();
    },
    onAddSupplierModal() {
      this.$refs.supplierModal.showModal();
    },
  },
  computed: {
    ...mapState("auth", ["status"]),
    ...mapState("auth", ["help_tooltip_visible"]),
    ...mapState("auth", ["keyShortcuts"]),

    ...mapGetters("auth", ["GetUser"]),
    username: function () {
      if (this.GetUser && this.GetUser["first_name"]) {
        return this.GetUser["first_name"] ? this.GetUser["first_name"] : "";
      } else {
        return "";
      }
      // return this.GetUser["first_name"] + " " + this.GetUser["last_name"];
    },
    shopName: function () {
      return this.selected ? upperCase(this.selected.name) : "POS";
    },
    ...mapState("dashboard", ["sideArea"]),
    ...mapState("shops", ["selected"]),
  },
  created: function () {
    this.startTimer();
  },
};
</script>
<style>
.sticked-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 4px 5px;
}

.site_name {
  font-weight: 600;
  font-size: 16px;
  line-height: 143%;
  color: #000000;
}

.btn_keyboard {
  background-color: #d2d5dc;
}

.btn-cash-flow {
  background-color: #2f548c !important;
  border-color: #2f548c !important;
  color: white !important;
}

.btn-add-supplier {
  background-color: #2998bb !important;
  border-color: #2998bb !important;
  color: white !important;
}

.popover-text-style {
  font-size: 10px;
}

.popover-style {
  width: auto;
}
</style>
